import React from 'react';

import { useTranslation } from '@lt/localization';
import { getFormattedDuration } from 'src/utils/dateUtils';
import styled, { css } from 'styled-components';
import { getIcon } from './utils';

type Props = {
  value?: number;
  isMobile: boolean;
  isAdditional?: boolean; // это апгрейд до бизнеса -_-
  direct: boolean;
};

const FlightDuration = (props: Props) => {
  const { t } = useTranslation();
  const { value: seconds, isMobile, isAdditional = false, direct } = props;
  const Icon = getIcon(isMobile, isAdditional, direct);

  const titleAll = isMobile ? '' : t('commonPages.titleAll');
  const formattedDuration =
    seconds && getFormattedDuration(seconds, t('commonPages.distanceM'));

  const duration = seconds ? `${titleAll} ${formattedDuration}` : null;

  return (
    <IconWrapper>
      {duration}
      <Icon />
    </IconWrapper>
  );
};

const IconWrapper = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;

  min-width: 140px;

  ${($isMobile) =>
    $isMobile &&
    css`
      display: flex;
      flex-direction: column;
      font-size: 11px;
      color: #4d4d4d;

      min-width: 100px;
    `}
`;

export default FlightDuration;
